<div class="p-m">
<h2 mat-dialog-title>Legen Sie ein neues Passwort fest</h2>
<div mat-dialog-content>
  <app-password [token]="data.token" [type]="'reset'" [requiresPassword]="true" (success)="closeDialog($event)"></app-password>
</div>
</div>
